import React from 'react'
import { useInView } from 'react-intersection-observer'
import './StartNow.scss'
import Plane01 from '../Assets/Icons/plane01.svg'
import Plane02 from '../Assets/Icons/plane02.svg'
import { Link } from 'react-router-dom'
import { useLanguage } from '../Contexts/LanguageContext'

const StartNow = () => {
    const { ref: ref1, inView: v1 } = useInView({ threshold: 0.5, triggerOnce: false });
    const { ref: ref2, inView: v2 } = useInView({ threshold: 0.5, triggerOnce: false });
    const { language } = useLanguage();

    return (
        <div className='start-now'>
            <h2>{language === 'polish' ? 'Zacznij teraz' : 'Start Now'}</h2>
            <div className='start-now-row'>
                <img src={Plane01} ref={ref1} alt="plane icon" className={`plane-icon plane-icon-1 ${v1 ? 'plane-active' : ''}`} />
                <h3>{language === 'polish' ? 'Zacznij kampanię reklamową' : 'Start Advertising Campaign'}</h3>

            </div>
            <div className='start-now-row'>
                <img src={Plane02} ref={ref2} alt="plane icon" className={`plane-icon plane-icon-2 ${v2 ? 'plane-active' : ''}`} />
                <h3>{language === 'polish' ? 'Dodaj swój kanał lub aplikację do monetyzacji' : 'Add Your Channel or App for Monetization'}</h3>
            </div>
            <a href='./#format-reklam' className='learn-more-link'>
                <p>{language === 'polish' ? 'Dowiedz się więcej' : 'Learn More'}</p>
            </a>
            <Link to='./login' >
                <div className='clinknest-btn-black'>{language === 'polish' ? 'Załóż konto' : 'Create Account'}</div>
            </Link>
        </div>
    )
}

export default StartNow